/* Midland theme scripts: slideshow, product variants, gallery, quantity, sort. */
(function () {
  'use strict';

  /* ---------- Slideshow ---------- */
  function initSlideshow(root) {
    if (root.dataset.ready) return;
    root.dataset.ready = 'true';
    var track = root.querySelector('.slideshow__track');
    var slides = Array.prototype.slice.call(root.querySelectorAll('.slide'));
    var dots = Array.prototype.slice.call(root.querySelectorAll('.slideshow__dot'));
    if (!track || slides.length < 2) return;
    var index = 0;
    var timer = null;
    var autoplay = root.dataset.autoplay === 'true';
    var speed = (parseInt(root.dataset.speed, 10) || 5) * 1000;

    function goTo(i) {
      index = (i + slides.length) % slides.length;
      track.scrollTo({ left: slides[index].offsetLeft, behavior: 'smooth' });
    }
    function setDots() {
      dots.forEach(function (d, i) { d.setAttribute('aria-current', i === index ? 'true' : 'false'); });
    }
    function start() { if (autoplay && !timer) timer = setInterval(function () { goTo(index + 1); }, speed); }
    function stop() { clearInterval(timer); timer = null; }

    track.addEventListener('scroll', function () {
      var i = Math.round(track.scrollLeft / track.clientWidth);
      if (i !== index) { index = i; }
      setDots();
    }, { passive: true });

    var prev = root.querySelector('.slideshow__arrow--prev');
    var next = root.querySelector('.slideshow__arrow--next');
    if (prev) prev.addEventListener('click', function () { stop(); goTo(index - 1); });
    if (next) next.addEventListener('click', function () { stop(); goTo(index + 1); });
    dots.forEach(function (d, i) { d.addEventListener('click', function () { stop(); goTo(i); }); });
    root.addEventListener('mouseenter', stop);
    root.addEventListener('focusin', stop);
    root.addEventListener('mouseleave', start);
    if (!window.matchMedia('(prefers-reduced-motion: reduce)').matches) start();
    setDots();
  }

  /* ---------- Product gallery ---------- */
  function showMedia(root, mediaId) {
    var slides = root.querySelectorAll('.product__slide');
    var thumbs = root.querySelectorAll('.product__thumb');
    var found = false;
    slides.forEach(function (s) {
      var on = s.dataset.mediaId === String(mediaId);
      if (on) found = true;
      s.classList.toggle('is-active', on);
    });
    if (!found) return;
    thumbs.forEach(function (t) { t.setAttribute('aria-current', t.dataset.mediaId === String(mediaId) ? 'true' : 'false'); });
  }

  function initProduct(root) {
    if (root.dataset.ready) return;
    root.dataset.ready = 'true';

    root.querySelectorAll('.product__thumb').forEach(function (t) {
      t.addEventListener('click', function () { showMedia(root, t.dataset.mediaId); });
    });

    var dataEl = root.querySelector('[data-variant-json]');
    var selects = root.querySelectorAll('[data-option-index]');
    var idInput = root.querySelector('input[name="id"]');
    var priceEl = root.querySelector('[data-price]');
    var compareEl = root.querySelector('[data-compare]');
    var button = root.querySelector('[data-add-button]');
    var stockEl = root.querySelector('[data-stock]');
    if (!dataEl || !selects.length) return;
    var variants = JSON.parse(dataEl.textContent);

    function update() {
      var chosen = Array.prototype.map.call(selects, function (s) { return s.value; });
      var variant = variants.find(function (v) {
        return v.options.every(function (o, i) { return o === chosen[i]; });
      });
      if (!variant) {
        if (button) { button.disabled = true; button.textContent = 'Unavailable'; }
        return;
      }
      if (idInput) idInput.value = variant.id;
      if (priceEl) priceEl.textContent = variant.price;
      if (compareEl) { compareEl.textContent = variant.compare || ''; compareEl.hidden = !variant.compare; }
      if (button) {
        button.disabled = !variant.available;
        button.textContent = variant.available ? 'Add to basket' : 'Sold out';
      }
      if (stockEl) stockEl.textContent = variant.available ? 'In stock, ready to ship' : 'Out of stock';
      if (variant.media) showMedia(root, variant.media);
      var url = new URL(window.location.href);
      url.searchParams.set('variant', variant.id);
      window.history.replaceState({}, '', url.toString());
    }
    selects.forEach(function (s) { s.addEventListener('change', update); });
  }

  /* ---------- Quantity steppers ---------- */
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-qty]');
    if (!btn) return;
    var input = btn.parentElement.querySelector('input');
    var min = parseInt(input.min, 10) || 0;
    var val = (parseInt(input.value, 10) || 0) + (btn.dataset.qty === 'plus' ? 1 : -1);
    input.value = Math.max(min, val);
    input.dispatchEvent(new Event('change', { bubbles: true }));
  });

  /* ---------- Collection sort ---------- */
  document.addEventListener('change', function (e) {
    if (!e.target.matches('[data-sort]')) return;
    var url = new URL(window.location.href);
    url.searchParams.set('sort_by', e.target.value);
    url.searchParams.delete('page');
    window.location.href = url.toString();
  });

  function init(scope) {
    (scope || document).querySelectorAll('[data-slideshow]').forEach(initSlideshow);
    (scope || document).querySelectorAll('[data-product]').forEach(initProduct);
  }

  document.addEventListener('DOMContentLoaded', function () { init(); });
  /* Re-initialise when sections are edited in the theme editor */
  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
})();
